import React, { useCallback, useReducer } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';
import { Modal } from 'ksnm-common-ui/lib/Modal';

import { publicationRegisterStore } from '../../../../stores/publicationRegisterStore';
import { ReportTree } from './ReportTree';

import styles from './DownloadReportExcelModal.module.scss';

interface IDownloadReportExcelModal {
  open: boolean;
  toggle: () => void;
}

export const DownloadReportExcelModal = observer(({ open, toggle }: IDownloadReportExcelModal) => {
  const [fullMode, toggleFullMode] = useReducer((state) => !state, false);

  const { setDownloadReports } = publicationRegisterStore;

  const onClose = useCallback(() => {
    setDownloadReports(null);
    toggle();
  }, [setDownloadReports, toggle]);

  return (
    <Modal
      open={open}
      className={cm(styles.modal, { [styles.fullMode]: fullMode })}
      centered
      footer={null}
      onCancel={onClose}
      width={fullMode ? '98vw' : 1000}
      closeIcon={<Icon name="close" noFill height={24} />}
      destroyOnClose
    >
      <div className={styles.container}>
        <h1 className={styles.title}>Скачать отчеты</h1>
        <ReportTree onClose={onClose} />
      </div>

      <IconButton
        extendClass={styles.fullscreenBtn}
        onClick={toggleFullMode}
        iconName={fullMode ? 'fullScreenOpen' : 'fullScreenClose'}
        fill="black"
        title={fullMode ? 'Свернуть' : 'На весь экран'}
      />
    </Modal>
  );
});
